import { put, call, select } from 'redux-saga/effects';
import { pick } from 'lodash/fp';
import * as actions from '../actions';
import { fetchApplicationDetails, fetchConsents } from '../../api/application';
import { submitApplicationStart } from '../actions';
import * as actionTypes from '../actions/actionTypes';

export function* fetchApplicationSaga(action) {
    try {
        yield put({ type: { type: actionTypes.GET_APPLICATION_DETAILS_START } });
        const response = yield call(fetchApplicationDetails, action.sessionId);

        const myInfoLessThanSixMonths = response.data?.data?.myInfoLessThanSixMonths;
        const createCustomerFlow = response.data?.data?.createCustomerFlow;
        let stage = 2;

        if (createCustomerFlow) {
            if (myInfoLessThanSixMonths) {
                yield put(actions.updateSource(true));
                // call submission api
                // then return
                try {
                    yield put(
                        submitApplicationStart(
                            response.data.data.applicationDetails,
                            response.data.data.applicantDetails,
                            [],
                            []
                        )
                    );
                } catch (error) {
                    yield put(actions.stageSuccess(11));
                }

                return;
            }

            stage = myInfoLessThanSixMonths ? 7 : 3;
        }

        yield put({ type: actions.getApplicationDetailsSuccess(response.data) });

        yield put(
            actions.updateFlowFlags({
                ...pick(
                    ['createCustomerFlow', 'myinfoUrl', 'myinfoWithCPF', 'corpCustomer', 'myInfoLessThanSixMonths', 'codeVerifier'],
                    response.data.data
                ),
                stage,
            })
        );

        if (!createCustomerFlow) {
            const state = yield select();
            const consentsResponse = yield call(
                fetchConsents,
                state.main.clientId,
                response.data?.data?.applicationDetails?.product,
                action.sessionId
            );

            yield put({ type: actions.onGetConsentsSuccess(consentsResponse.data.data) });
        }
    } catch (error) {
        yield put(actions.stageSuccess(2)); // Your Application
        yield put({ type: actions.getApplicationDetailsFailed(error.response.data.msg) });
    }
}
